(function() {
  'use strict';

  // Initialize swiper slider based on data-attributes (replicates theme swiper settings)
  function initSwiper(swiperEl) {
    if (!swiperEl) return;

    const spaceMobile = Number(swiperEl.dataset.spaceBetweenMobile) || 16;
    const spaceTablet = Number(swiperEl.dataset.spaceBetweenTablet) || 16;
    const spaceDesktop = Number(swiperEl.dataset.spaceBetweenDesktop) || 32;
    const mobileLayout = swiperEl.dataset.mobileLayout || 'slider';
    const desktopLayout = swiperEl.dataset.desktopLayout || 'slider';
    const mediaMobile = window.matchMedia('(min-width: 0px) and (max-width: 1023px)');
    const mediaDesktop = window.matchMedia('(min-width: 1024px)');

    const updateSwiper = () => {
      if ((mediaDesktop.matches && desktopLayout === 'slider') || (mediaMobile.matches && mobileLayout === 'slider')) {
        if (!swiperEl.swiper || swiperEl.swiper.destroyed) {
          const mobileSlides = parseFloat(swiperEl.dataset.mobileSlidesPerView) || 'auto';
          const tabletSlides = '0' !== swiperEl.dataset.tabletSlidesPerView && swiperEl.dataset.tabletSlidesPerView ? parseFloat(swiperEl.dataset.tabletSlidesPerView) : mobileSlides;
          const desktopSlides = parseFloat(swiperEl.dataset.desktopSlidesPerView) || 'auto';
          
          const params = {
            breakpoints: {
              0: { slidesPerView: mobileSlides, spaceBetween: spaceMobile },
              768: { slidesPerView: tabletSlides, spaceBetween: spaceTablet },
              1024: { slidesPerView: desktopSlides, spaceBetween: spaceDesktop }
            }
          };
          
          Object.assign(swiperEl, params);

          swiperEl.addEventListener('swiperafterinit', () => {
            const section = swiperEl.closest('.shopify-section');
            if (section) section.classList.add('slider-enabled');

            setTimeout(() => {
              if (!swiperEl.swiper) return;
              const activeMobile = mobileSlides;
              const activeTablet = tabletSlides;
              const activeDesktop = desktopSlides;

              if (swiperEl.swiper.params && swiperEl.swiper.params.breakpoints) {
                swiperEl.swiper.currentBreakpoint = false;
                swiperEl.swiper.params.breakpoints[0].slidesPerView = activeMobile;
                swiperEl.swiper.params.breakpoints[768].slidesPerView = activeTablet;
                swiperEl.swiper.params.breakpoints[1024].slidesPerView = activeDesktop;
                swiperEl.swiper.update();
                swiperEl.swiper.slideTo(0, 0, false);
              }

              // Play autoplaying videos in visible slides
              swiperEl.querySelectorAll('video').forEach(video => {
                if (video.hasAttribute('autoplay') && !video.classList.contains('section__wrapper-background')) {
                  video.play().catch(() => {});
                }
              });
            }, 0);
          });

          // Handle slide change videos
          swiperEl.addEventListener('swiperslidechange', () => {
            swiperEl.querySelectorAll('video').forEach(video => {
              if (!video.classList.contains('section__wrapper-background')) {
                video.pause();
              }
            });
            const visibleSlides = Array.from(swiperEl.querySelectorAll('swiper-slide')).filter(s => s.classList.contains('swiper-slide-visible'));
            visibleSlides.forEach(slide => {
              const video = slide.querySelector('video');
              if (video && video.hasAttribute('autoplay')) {
                video.play().catch(() => {});
              }
            });
          });

          swiperEl.addEventListener('swiperdestroy', () => {
            const section = swiperEl.closest('.shopify-section');
            if (section) section.classList.remove('slider-enabled');
          });

          swiperEl.initialize();
        } else {
          swiperEl.swiper.update();
        }
      } else {
        // Grid layout - destroy swiper if it exists
        if (swiperEl.swiper) {
          swiperEl.swiper.destroy(true, true);
          const section = swiperEl.closest('.shopify-section');
          if (section) section.classList.remove('slider-enabled');
        }
        swiperEl.initialize();
      }
    };

    window.addEventListener('resize', updateSwiper);
    updateSwiper();
  }

  // Setup AJAX add to cart handler for dynamically loaded product forms
  function initCartForm(form) {
    if (!form) return;
    if (form.dataset.cartFormInitialized) return;
    form.dataset.cartFormInitialized = '1';
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const submitButton = form.querySelector('button[type="submit"]');
      const buttonText = submitButton ? submitButton.querySelector('span:not(.cart-icon):not(:empty)') : null;
      const cartIcon = submitButton ? submitButton.querySelector('span.cart-icon') : null;
      const loadingIcon = submitButton ? submitButton.querySelector('svg.loading-icon') : null;

      if (buttonText) buttonText.textContent = window.cartStrings ? window.cartStrings.addingToCart : 'Adding...';
      if (submitButton) submitButton.classList.add('added');
      if (cartIcon) cartIcon.style.display = 'none';
      if (loadingIcon) loadingIcon.style.display = 'block';
      document.body.classList.remove('added-to-cart');

      const formData = new FormData(form);
      formData.append('sections', 'main-cart');

      fetch(window.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
      .then(res => res.json())
      .then(data => {
        if (data.status) {
          // Error response (e.g. inventory issues)
          if (window.cartService && typeof window.cartService.updateMiniCart === 'function') {
            window.cartService.updateMiniCart(true);
          }
          if (cartIcon) cartIcon.style.display = 'inline-flex';
          if (loadingIcon) loadingIcon.style.display = 'none';
          if (buttonText) buttonText.textContent = window.cartStrings ? window.cartStrings.addToCart : 'Add to Cart';

          const errorEl = form.querySelector('.main-product__error');
          if (errorEl) {
            let msg = data.description;
            if (typeof data.description === 'object') {
              msg = Object.entries(data.description).map(([k, v]) => `${v.join(', ')}`).join(', ');
            }
            errorEl.innerHTML = `<span class="icon loaded">error</span><p>${msg}</p>`;
          }
        } else {
          // Success
          if (window.cartStrings && window.cartStrings.uxCart === 'cart') {
            window.location.href = window.routes.cart;
            return;
          }

          const errorEl = form.querySelector('.main-product__error');
          if (errorEl) errorEl.innerHTML = '';

          const mainCart = document.getElementById('main-cart');
          if (mainCart) mainCart.classList.add('added');

          if (data.sections && data.sections['main-cart'] && window.cartService && typeof window.cartService.renderItems === 'function') {
            window.cartService.renderItems(new DOMParser().parseFromString(data.sections['main-cart'], 'text/html'));
          } else {
            fetch(`${window.location.pathname}?section_id=main-cart`)
              .then(res => res.text())
              .then(text => {
                if (window.cartService && typeof window.cartService.renderItems === 'function') {
                  window.cartService.renderItems(new DOMParser().parseFromString(text, 'text/html'));
                }
              });
          }

          const miniCart = document.getElementById('mini-cart');
          if (window.cartStrings && window.cartStrings.uxCart === 'mini-cart' && miniCart && typeof miniCart.open === 'function') {
            miniCart.open();
          }

          if (buttonText) buttonText.textContent = window.cartStrings ? window.cartStrings.addedToCart : 'Added';
          if (submitButton) {
            submitButton.classList.remove('added');
            submitButton.classList.add('successful');
          }
          if (cartIcon) cartIcon.style.display = 'flex';
          if (loadingIcon) loadingIcon.style.display = 'none';
          document.body.classList.add('added-to-cart');
        }
      })
      .catch(err => {
        console.error('Error adding to cart:', err);
      });
    });
  }

  // Load recently viewed products
  function initRecentlyViewed() {
    const placeholders = document.querySelectorAll('.recently-viewed-products-placeholder:not(.is-loaded)');
    if (!placeholders.length) return;

    let recentlyViewed = [];
    try {
      recentlyViewed = JSON.parse(localStorage.getItem('naughtynest-recently-viewed')) || [];
    } catch (e) {
      console.error('Failed to parse recently viewed products', e);
      return;
    }

    placeholders.forEach(placeholder => {
      placeholder.classList.add('is-loaded');

      const sectionId = placeholder.dataset.sectionId;
      const currentProduct = placeholder.dataset.currentProduct;
      const limit = parseInt(placeholder.dataset.limit) || 12;

      // Filter out the product the user is currently viewing (if on a product page)
      let handles = recentlyViewed;
      if (currentProduct) {
        handles = handles.filter(handle => handle !== currentProduct);
      }

      // Slice to match settings limit
      handles = handles.slice(0, limit);

      const sectionWrapper = placeholder.closest('.shopify-section');

      if (handles.length === 0) {
        if (sectionWrapper) {
          sectionWrapper.classList.add('u-hide');
        }
        return;
      }

      // Construct search query
      const query = handles.map(h => `handle:${h}`).join(' OR ');
      const searchUrl = `${placeholder.dataset.url}?type=product&q=${encodeURIComponent(query)}&limit=50&section_id=${sectionId}`;

      fetch(searchUrl)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newPlaceholder = doc.querySelector('.recently-viewed-products-placeholder');

          if (newPlaceholder && newPlaceholder.querySelector('swiper-container, .grid')) {
            placeholder.innerHTML = newPlaceholder.innerHTML;

            const swiperContainer = placeholder.querySelector('swiper-container');
            if (swiperContainer) {
              // Reorder swiper-slides to preserve localStorage chronological order
              const slides = Array.from(swiperContainer.querySelectorAll('swiper-slide'));
              slides.sort((slideA, slideB) => {
                const handleA = slideA.dataset.handle;
                const handleB = slideB.dataset.handle;
                return handles.indexOf(handleA) - handles.indexOf(handleB);
              });
              slides.forEach(slide => swiperContainer.appendChild(slide));

              // Initialize Swiper
              initSwiper(swiperContainer);
            }

            // Initialize dynamic cart forms in cards
            placeholder.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
              initCartForm(form);
            });

            // Initialize image lazyloading or icons if necessary
            placeholder.querySelectorAll('.icon').forEach(icon => {
              icon.classList.add('loaded');
            });

            if (sectionWrapper) {
              sectionWrapper.classList.add('u-hide');
              // Briefly hide and show to animate naturally
              setTimeout(() => {
                sectionWrapper.classList.remove('u-hide');
              }, 200);
            }
          } else {
            if (sectionWrapper) {
              sectionWrapper.classList.add('u-hide');
            }
          }
        })
        .catch(err => {
          console.error('Error fetching recently viewed products:', err);
          if (sectionWrapper) {
            sectionWrapper.classList.add('u-hide');
          }
        });
    });
  }

  // Load on DOMContentLoaded and theme editor changes
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecentlyViewed);
  } else {
    initRecentlyViewed();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.classList.contains('recently-viewed-products') || e.target.querySelector('.recently-viewed-products-placeholder')) {
      initRecentlyViewed();
    }
  });

})();
